(function () {
  'use strict';
  var names = ['TROPICAL', 'AVIARA', 'IMPERIA', 'BIANCA', 'MISARA', 'ATELIER',
    'TULIP', 'SIENA', 'INFINITY', 'RIVIERA', 'SUNSHINE', 'KRISTA', 'GLORY',
    'MOSAIC', 'MAISON', 'IDA', 'TWIST', 'MAJESTIC', 'GOLDEN DRAGON', 'DRAGONFLY', 'BUTTERFLY', 'SOLAR GLOW',
    'GOOD LUCK', 'NEW YEAR', 'PALMPARADISE', 'PALM', 'GREEN', 'RUBY'];
  var letters = 'A-Za-zÇĞİÖŞÜçğıöşü';
  var pattern = names.map(function (name) {
    return name.replace(/I/g, '[Iİiı]').replace(/ /g, '\\s+');
  }).join('|');
  var expression = new RegExp('(^|[^' + letters + '])(' + pattern + ')(?=$|[^' + letters + '])', 'gi');
  function correct(root) {
    if (!root || !root.isConnected) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    function fix(textNode) {
      var parent = textNode.parentElement;
      if (!parent || parent.closest('script,style,noscript,textarea,[contenteditable]')) return;
      var value = textNode.nodeValue;
      expression.lastIndex = 0;
      if (!expression.test(value)) return;
      expression.lastIndex = 0;
      var uppercase = getComputedStyle(parent).textTransform === 'uppercase';
      var next = value.replace(expression, function (full, prefix, brand) {
        var canonical = brand.replace(/[İı]/g, 'i').replace(/\s+/g, ' ').toUpperCase();
        var alreadyUppercase = brand === brand.toUpperCase();
        return prefix + (uppercase || alreadyUppercase ? canonical : brand);
      });
      if (next !== value) textNode.nodeValue = next;
    }
    if (root.nodeType === Node.TEXT_NODE) fix(root);
    else while ((node = walker.nextNode())) fix(node);
  }
  function start() {
    correct(document.body);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) { correct(node); });
      });
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function (event) { correct(event.target); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
